import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sharedFullName',
    standalone: false
})
export class SharedFullNamePipe implements PipeTransform {
  transform(name: { firstName: string; middleName?: string; lastName: string } | null): string {
    if (!name) {
      return '-';
    }
    return [name.firstName, name.middleName, name.lastName]
      .filter((name: string | null | undefined) => !!name)
      .join(' ');
  }
}
